import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { CredentialsServiceProxy, UserServiceProxy, CreateCredentialsInput, EventsServiceProxy, CreateOrEditCredentialDto, EnterpriseServiceProxy } from '@shared/service-proxies/service-proxies';

import * as _ from 'lodash';
import { FileDownloadService } from '@shared/utils/file-download.service';

@Component({
    selector: 'createOrEditCredentialModal',
    templateUrl: './create-or-edit-credential-modal.component.html'
})

export class CreateOrEditCredentialModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal') modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    inputCredentials: CreateCredentialsInput = new CreateCredentialsInput();

    countName = 0;
    eventCredentials = undefined;
    enterpriseCredentials = undefined;

    users = [];
    events = [];
    enterprises = [];

    constructor(
        injector: Injector,
        private _userService: UserServiceProxy,
        private _eventsService: EventsServiceProxy,
        private _credentialService: CredentialsServiceProxy,
        private _enterpriseService: EnterpriseServiceProxy,
        private _fileDownloadService: FileDownloadService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.initialize();
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }

    onShown(): void {
        this.modal.show();
    }

    initialize(): void {
        this.countName = 0;
        this.eventCredentials = undefined;
        this.enterpriseCredentials = undefined;
        this.inputCredentials.credentials = [];

        this.addCredential(1);
    }

    public show(): void {

        this.initialize();
        this.active = true;
        this.modal.show();
    }

    save(): void {

        let model = new CreateCredentialsInput();
        model.credentials = [];

        this.inputCredentials.credentials.forEach(x => {

            let credential = new CreateOrEditCredentialDto();
            credential.eventId = this.eventCredentials.id;
            credential.exhibitorId = this.enterpriseCredentials.id;

            let value: any = x.user;

            if (typeof value === "string") {
                credential.name = value;
            }
            else {
                credential.name = x.user.name;
                credential.userId = x.user.id;
            }
            model.credentials.push(credential);
        })

        this._credentialService.createCredentials(model)
            .finally(() => { this.saving = false; })
            .subscribe(result => {

                this._fileDownloadService.downloadTempFile(result);

                this.close();
                this.notify.info(this.l('SavedSuccessfully'));
                this.modalSave.emit(null);
            });
    }

    // Get Users
    filterUsers(event): void {
        this._userService.getUsersForSelect(
                event.query,
                undefined,
                20,
                0
            ).subscribe(result => {
            this.users = result.items;
        });
    }

    // Get Events
    filterEvents(event): void {
        this._eventsService.getEventsForSelect(event.query, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 10, 0).subscribe(result => {
            this.events = result.items;
        });
    }

    // Get Institutions
    filterEnterprises(event): void {
        this._enterpriseService.getEnterpriseForSelectAsync(
                event.query,
                undefined,
                undefined,
            ).subscribe(result => {
                this.enterprises = result.items;
        });
    }

    addCredential(quantity: number): void {

        for (let index = 0; index < quantity; index++) {
            let credential = new CreateOrEditCredentialDto();
            credential.id = this.countName--;
            this.inputCredentials.credentials.push(credential);
        }
    }

    deleteCredential(index: number): void {
        this.inputCredentials.credentials.splice(index, 1);
    };
}



// WEBPACK FOOTER //
// ./src/app/event/credentials/modal/create-or-edit-credential-modal.component.ts